import { Role } from '@sakura/prisma/enums';

export interface PermissionItem {
  key: string;
  label: string;
}

export interface PermissionGroup {
  key: string;
  label: string;
  permissions: PermissionItem[];
}

export const PERMISSION_CATALOG: PermissionGroup[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    permissions: [{ key: 'dashboard.view', label: 'View Dashboard' }],
  },
  {
    key: 'registration',
    label: 'Registration',
    permissions: [
      { key: 'companies.view', label: 'Company Registration' },
      { key: 'products.view', label: 'Product Info' },
      { key: 'generics.view', label: 'Generic Info' },
      { key: 'groups.view', label: 'Group Info' },
    ],
  },
  {
    key: 'purchase',
    label: 'Purchase Module',
    permissions: [
      { key: 'purchases.view', label: 'Stock-In' },
      { key: 'stock.adjust', label: 'Stock Adjust' },
      { key: 'purchase.payments', label: 'Purchase Payment' },
      { key: 'stock.audit', label: 'Stock Audit' },
    ],
  },
  {
    key: 'sales',
    label: 'Sales Module',
    permissions: [
      { key: 'sales.ipd', label: 'IPD Sales' },
      { key: 'sales.opd', label: 'OPD Sales' },
      { key: 'sales.staff', label: 'Staff Sales' },
      { key: 'sales.internal', label: 'Internal Sales' },
    ],
  },
  {
    key: 'refund',
    label: 'Refund Section',
    permissions: [
      { key: 'refund.ipd', label: 'IPD Refund' },
      { key: 'refund.opd', label: 'OPD Refund' },
      { key: 'refund.damage', label: 'Damage Refund' },
    ],
  },
  {
    key: 'billing-staff',
    label: 'Billing Section (Staff)',
    permissions: [{ key: 'billing.staff', label: 'Staff Collection' }],
  },
  {
    key: 'billing-ipd',
    label: 'Billing Section (IPD)',
    permissions: [{ key: 'billing.ipd', label: 'IPD Advance' }],
  },
  {
    key: 'reports',
    label: 'Reports',
    permissions: [{ key: 'reports.mis', label: 'MIS Reports' }],
  },
];

export const ALL_PERMISSIONS = PERMISSION_CATALOG.flatMap((group) =>
  group.permissions.map((permission) => permission.key),
);

const defaults: Record<Role, string[]> = {
  [Role.SUPER_ADMIN]: ALL_PERMISSIONS,
  [Role.ADMIN]: ALL_PERMISSIONS,
  [Role.PHARMACIST]: [
    'dashboard.view',
    'products.view',
    'sales.ipd',
    'sales.opd',
    'sales.staff',
    'refund.ipd',
    'refund.opd',
  ],
  [Role.CASHIER]: [
    'dashboard.view',
    'sales.ipd',
    'sales.opd',
    'sales.staff',
    'refund.ipd',
    'refund.opd',
    'billing.staff',
    'billing.ipd',
  ],
  [Role.INVENTORY_MANAGER]: [
    'dashboard.view',
    'companies.view',
    'products.view',
    'generics.view',
    'groups.view',
    'purchases.view',
    'stock.adjust',
    'purchase.payments',
    'stock.audit',
  ],
  [Role.ACCOUNTANT]: [
    'dashboard.view',
    'purchase.payments',
    'billing.staff',
    'billing.ipd',
    'reports.mis',
  ],
  [Role.AUDITOR]: [
    'dashboard.view',
    'stock.audit',
    'reports.mis',
  ],
};

export function defaultPermissions(role: Role): string[] {
  return [...defaults[role]];
}
